import { useEffect, useState } from 'react';
import { apiService } from '../services/api';

// Environments that get no badge: prod is the real thing, and local dev is
// obvious from the localhost URL. Anything else (stg, test…) is labelled so
// nobody mistakes a staging tab for production.
const UNBADGED = new Set(['prod', 'dev']);

export const EnvironmentBanner = () => {
  const [environment, setEnvironment] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiService.getEnvironment().then((env) => {
      if (!cancelled) setEnvironment(env);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!environment || UNBADGED.has(environment)) return null;

  const label = environment === 'stg' ? 'STAGING' : environment.toUpperCase();
  return (
    <div
      role="status"
      aria-label={`${label} environment`}
      style={{
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        pointerEvents: 'none',
        padding: '2px 14px',
        borderRadius: '0 0 6px 6px',
        background: '#d97706',
        color: '#fff',
        fontFamily: 'Lato, system-ui, sans-serif',
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: '0.08em',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
      }}
    >
      {label} — not production data
    </div>
  );
};
